// extracted by mini-css-extract-plugin
export var csatScore = "_h7-5";
export var header = "_h7-1";
export var panelWrapper = "_h7-2";
export var postPreview = "_h7-3";
export var rightContent = "_h7-0";
export var wrappingText = "_h7-4";